(function () {
  "use strict";

  var SELECTORS = {
    drawer: "[data-ferrer-cart-drawer]",
    body: "[data-ferrer-cart-body]",
    foot: "[data-ferrer-cart-foot]",
    subtotal: "[data-ferrer-cart-subtotal]",
    progress: "[data-ferrer-cart-progress]",
    progressText: "[data-ferrer-cart-progress-text]",
    progressFill: "[data-ferrer-cart-progress-fill]",
    count: "[data-ferrer-cart-count]"
  };

  var strings = window.ferrerCartStrings || {};
  var thresholds = window.ferrerFreeShippingThresholds || {};
  var activeCurrency = "USD";

  /* ---------- Routes (respeita /en-us/) ---------- */
  function cartRoot() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root.charAt(root.length - 1) === "/" ? root : root + "/";
  }

  function cartUrl(path) {
    return cartRoot() + path.replace(/^\//, "");
  }

  /* ---------- Strings (evita You&#39;ve no DOM) ---------- */
  function decodeEntities(value) {
    if (!value || value.indexOf("&") === -1) return value || "";
    var el = document.createElement("textarea");
    el.innerHTML = value;
    return el.value;
  }

  /* ---------- Money (usa cart.currency, não só shop.money_format) ---------- */
  function formatMoney(cents, currency) {
    var cur = (currency || activeCurrency || "USD").toUpperCase();
    var amount = Number(cents);
    if (typeof cents === "string") {
      amount = Number(String(cents).replace(/[^\d.-]/g, ""));
    }
    if (!isFinite(amount)) return "";

    try {
      return new Intl.NumberFormat(cur === "BRL" ? "pt-BR" : "en-US", {
        style: "currency",
        currency: cur
      }).format(amount / 100);
    } catch (e) {
      return (cur === "BRL" ? "R$ " : "$") + (amount / 100).toFixed(2);
    }
  }

  function thresholdFor(currency) {
    var cur = (currency || activeCurrency || "USD").toUpperCase();
    var value = thresholds[cur];
    if (value == null) {
      value = cur === "BRL" ? thresholds.BRL : thresholds.USD;
    }
    return Number(value) || 0;
  }

  /* ---------- Drawer ---------- */
  function drawer() {
    return document.querySelector(SELECTORS.drawer);
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.classList.add("nav-open");
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.classList.remove("nav-open");
  }

  /* ---------- Toast ---------- */
  function toast(message) {
    var el = document.createElement("div");
    el.className = "ferrer-toast";
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add("is-visible");
    });
    setTimeout(function () {
      el.classList.remove("is-visible");
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 2600);
  }

  /* ---------- Render ---------- */
  function updateCounts(count) {
    document.querySelectorAll(SELECTORS.count).forEach(function (node) {
      node.textContent = count;
      node.hidden = count < 1;
    });
  }

  function renderProgress(totalPrice, currency) {
    var d = drawer();
    if (!d) return;
    var wrap = d.querySelector(SELECTORS.progress);
    var threshold = thresholdFor(currency);
    if (!wrap || threshold <= 0) {
      if (wrap) wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    var textEl = d.querySelector(SELECTORS.progressText);
    var fillEl = d.querySelector(SELECTORS.progressFill);
    var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
    if (fillEl) fillEl.style.width = pct + "%";
    if (textEl) {
      if (totalPrice >= threshold) {
        textEl.textContent = decodeEntities(strings.freeShippingHave || "");
        wrap.classList.add("is-complete");
      } else {
        var remaining = formatMoney(threshold - totalPrice, currency);
        textEl.textContent = decodeEntities(strings.freeShippingLeft || "{{ amount }}").replace(
          "{{ amount }}",
          remaining
        );
        wrap.classList.remove("is-complete");
      }
    }
  }

  function lineHtml(item, index, currency) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[^.]+)(\?.*)?$/, "_160x$1") + '" alt="" loading="lazy">'
      : "";
    var variant =
      item.variant_title && item.variant_title !== "Default Title"
        ? '<p class="drawer-line__variant">' + item.variant_title + "</p>"
        : "";
    var onSale = item.original_line_price > item.final_line_price;
    var price =
      '<span class="drawer-line__price">' +
      (onSale ? "<s>" + formatMoney(item.original_line_price, currency) + "</s> " : "") +
      formatMoney(item.final_line_price, currency) +
      "</span>";

    return (
      '<article class="drawer-line" data-line="' +
      index +
      '">' +
      '<a href="' +
      item.url +
      '" class="drawer-line__media">' +
      img +
      "</a>" +
      '<div class="drawer-line__info">' +
      '<a href="' +
      item.url +
      '" class="drawer-line__title">' +
      item.product_title +
      "</a>" +
      variant +
      '<div class="drawer-line__bottom">' +
      '<div class="drawer-line__qty">' +
      '<button type="button" data-qty-decrease aria-label="-">&minus;</button>' +
      "<span data-qty-value>" +
      item.quantity +
      "</span>" +
      '<button type="button" data-qty-increase aria-label="+">+</button>' +
      "</div>" +
      price +
      "</div>" +
      '<button type="button" class="drawer-line__remove" data-remove>' +
      (strings.remove || "Remove") +
      "</button>" +
      "</div>" +
      "</article>"
    );
  }

  function renderCart(cart) {
    activeCurrency = (cart && cart.currency) || activeCurrency || "USD";
    updateCounts(cart.item_count);

    var d = drawer();
    if (!d) return;
    var body = d.querySelector(SELECTORS.body);
    var foot = d.querySelector(SELECTORS.foot);
    var subtotal = d.querySelector(SELECTORS.subtotal);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">' + (strings.empty || "") + "</p>";
      if (foot) foot.hidden = true;
      if (subtotal) subtotal.textContent = "";
      var prog = d.querySelector(SELECTORS.progress);
      if (prog) prog.hidden = true;
      return;
    }

    body.innerHTML = cart.items
      .map(function (item, i) {
        return lineHtml(item, i + 1, activeCurrency);
      })
      .join("");

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price, activeCurrency);
    if (foot) foot.hidden = false;
    renderProgress(cart.total_price, activeCurrency);
  }

  /* ---------- Fetch helpers ---------- */
  function getCart() {
    return fetch(cartUrl("cart.js"), { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function refresh() {
    return getCart().then(renderCart);
  }

  function addToCart(id, quantity) {
    return fetch(cartUrl("cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          throw new Error(err.description || err.message || "Error");
        });
      }
      return r.json();
    });
  }

  function changeLine(line, quantity) {
    return fetch(cartUrl("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) {
      return r.json();
    });
  }

  /* ---------- Actions ---------- */
  function handleAdd(id, quantity) {
    return addToCart(id, quantity)
      .then(function () {
        return refresh();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (e) {
        toast(e.message);
      });
  }

  /* ---------- Bindings ---------- */
  function bind() {
    if (document.body.dataset.ferrerCartBound === "true") return;
    document.body.dataset.ferrerCartBound = "true";

    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-ferrer-cart-toggle]");
      if (toggle) {
        event.preventDefault();
        openDrawer();
        refresh();
        return;
      }

      if (event.target.closest("[data-ferrer-cart-close]")) {
        closeDrawer();
        return;
      }

      var addNow = event.target.closest("[data-ferrer-add-now]");
      if (addNow) {
        event.preventDefault();
        handleAdd(addNow.getAttribute("data-variant-id"), 1);
        return;
      }

      var qaToggle = event.target.closest("[data-ferrer-quick-add-toggle]");
      if (qaToggle) {
        event.preventDefault();
        var wrap = qaToggle.closest("[data-ferrer-quick-add]");
        var panel = wrap && wrap.querySelector("[data-ferrer-quick-add-panel]");
        if (panel) {
          var willOpen = panel.hidden;
          panel.hidden = !willOpen;
          qaToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        }
        return;
      }

      var addVariant = event.target.closest("[data-ferrer-add-variant]");
      if (addVariant && !addVariant.disabled) {
        event.preventDefault();
        handleAdd(addVariant.getAttribute("data-ferrer-add-variant"), 1);
        return;
      }

      var dec = event.target.closest("[data-qty-decrease]");
      var inc = event.target.closest("[data-qty-increase]");
      var rem = event.target.closest("[data-remove]");
      if (dec || inc || rem) {
        event.preventDefault();
        var lineEl = event.target.closest("[data-line]");
        if (!lineEl) return;
        var line = parseInt(lineEl.getAttribute("data-line"), 10);
        var current = parseInt(lineEl.querySelector("[data-qty-value]").textContent, 10) || 1;
        var next = current;
        if (rem) next = 0;
        else if (dec) next = Math.max(1, current - 1);
        else if (inc) next = current + 1;
        changeLine(line, next).then(refresh).catch(function () {
          refresh();
        });
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeDrawer();
    });

    /* PDP add-to-cart form → AJAX + drawer */
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      event.preventDefault();
      var data = new FormData(form);
      var id = data.get("id");
      var qty = parseInt(data.get("quantity"), 10) || 1;
      handleAdd(id, qty);
    });

    /* Swatch hover → swap card image */
    document.addEventListener("mouseover", function (event) {
      var sw = event.target.closest("[data-ferrer-swatch]");
      if (!sw) return;
      var url = sw.getAttribute("data-image-url");
      if (!url) return;
      var card = sw.closest("[data-ferrer-card]");
      var img = card && card.querySelector(".product-card__image");
      if (img) {
        if (!img.dataset.originalSrc) img.dataset.originalSrc = img.currentSrc || img.src;
        img.src = url;
        img.srcset = "";
      }
    });
    document.addEventListener("mouseout", function (event) {
      var sw = event.target.closest("[data-ferrer-swatch]");
      if (!sw) return;
      var card = sw.closest("[data-ferrer-card]");
      var img = card && card.querySelector(".product-card__image");
      if (img && img.dataset.originalSrc) img.src = img.dataset.originalSrc;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    bind();
    refresh();
  });
})();
